export default "__VITE_ASSET__32091411__"